module.exports = __webpack_public_path__ + "img/admin-a5.37f3352f.png";